module.exports = __webpack_public_path__ + "static/media/adserver_decorative_section4.d54bbd59.png";